import { BasePageableBuilder } from '@ravago/shared/page-data/builders/base';
import { BasePageableV2Builder } from '@ravago/shared/page-data/builders/base/base-pageable-v2.builder';
import { AutoSuggestQueryArgs, AutoSuggestQueryV2Args, AutoSuggestResponse, AutoSuggestV2Response } from '@ravago/shared/page-data/models/elastic';

export abstract class ElasticUtils {
  static async getAutosuggestResult(request: AutoSuggestQueryArgs, correlationId: string): Promise<AutoSuggestResponse> {
    const response = await fetch(`/api/elastic/auto-suggest?autosuggestArgs=${JSON.stringify({ args: request, correlationId })}`);

    if (response.ok) {
      return response.json();
    }
    return {
      searchResult: {
        content: [],
        ...BasePageableBuilder.aBasePageable().withPageIndex(0).withTotalNumberOfElements(0).withNumberOfElementsPerPage(request.size).build()
      },
      suggestedFilters: []
    };
  }

  static async getAutosuggestV2Result(request: AutoSuggestQueryV2Args, correlationId: string): Promise<AutoSuggestV2Response> {
    const response = await fetch(`/api/elastic/auto-suggest-v2?autosuggestArgs=${JSON.stringify({ args: request, correlationId })}`);

    if (response.ok) {
      return response.json();
    }
    return {
      searchResult: {
        content: [],
        ...BasePageableV2Builder.aBasePageable().withCurrentPage(0).withTotalNumberOfElements(0).withPageSize(request.size).build()
      },
      suggestedFilters: []
    };
  }
}
